import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";
import type {
  CostBaseResponse,
  CostPeriod,
  CostProductOption,
  CreateCostPeriodPayload,
  SaveCostBasePayload,
} from "../types/costManagement";

export const costManagementApi = createApi({
  reducerPath: "costManagementApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["CostPeriods", "CostProducts", "CostBase"],
  endpoints: (builder) => ({
    getCostPeriods: builder.query<CostPeriod[], void>({
      query: () => "/cost-periods",
      transformResponse: (raw: { status: string; data: CostPeriod[] }) =>
        raw.data,
      providesTags: ["CostPeriods"],
    }),
    createCostPeriod: builder.mutation<CostPeriod, CreateCostPeriodPayload>({
      query: (body) => ({ url: "/cost-periods", method: "POST", body }),
      transformResponse: (raw: { status: string; data: CostPeriod }) =>
        raw.data,
      invalidatesTags: ["CostPeriods"],
    }),
    getCostProducts: builder.query<CostProductOption[], void>({
      query: () => "/cost-products",
      transformResponse: (raw: { status: string; data: CostProductOption[] }) =>
        raw.data,
      providesTags: ["CostProducts"],
    }),
    getCostBase: builder.query<
      CostBaseResponse,
      { periodId: number; productId: number }
    >({
      query: ({ periodId, productId }) => ({
        url: "/cost-base",
        params: { periodId, productId },
      }),
      transformResponse: (raw: { status: string; data: CostBaseResponse }) =>
        raw.data,
      providesTags: ["CostBase"],
    }),
    saveCostBase: builder.mutation<CostBaseResponse, SaveCostBasePayload>({
      query: (body) => ({ url: "/cost-base", method: "PUT", body }),
      transformResponse: (raw: { status: string; data: CostBaseResponse }) =>
        raw.data,
      invalidatesTags: ["CostBase"],
    }),
  }),
});

export const {
  useGetCostPeriodsQuery,
  useCreateCostPeriodMutation,
  useGetCostProductsQuery,
  useGetCostBaseQuery,
  useSaveCostBaseMutation,
} = costManagementApi;
